// Ubicación en el repo: src/components/CategoryFormModal.jsx
// Modal Crear/Editar categoría de producto (Fase A del módulo de
// Inventario/Contabilidad, migración 0046, 24-ago-2026). Mismo patrón que
// BranchFormModal — un solo campo, así que va bien simple.
//
// Rol especial (migración 0050, 25-ago-2026): antes, la venta de audífonos
// dependía de que la categoría se llamara EXACTAMENTE "Audífono" — un
// renombre accidental la rompía en silencio. Se reemplaza por un flag
// explícito (`special_role`), independiente del nombre, elegido acá con un
// select en vez de comparar texto. Solo una categoría activa puede tener
// cada rol (índice único parcial en la migración) — si se elige uno que ya
// está en uso, el guardado falla con 23505 y se muestra un mensaje claro.
import { useState } from 'react';
import { createCategory, updateCategory } from '../lib/categories';

const SPECIAL_ROLES = [
  { value: '', label: '— (categoría normal)' },
  { value: 'audifono', label: 'Es la categoría de Audífonos' },
];

export default function CategoryFormModal({ category, onClose, onSaved }) {
  const isEdit = !!category;
  const [name, setName] = useState(category?.name ?? '');
  const [specialRole, setSpecialRole] = useState(category?.special_role ?? '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (!name.trim()) {
      setError('El nombre es obligatorio.');
      return;
    }
    setSaving(true);
    try {
      if (isEdit) {
        await updateCategory(category.id, name, specialRole);
      } else {
        await createCategory(name, specialRole);
      }
      onSaved();
    } catch (err) {
      if (err.code === '23505' && err.message?.includes('special_role')) {
        setError('Ya existe otra categoría activa con ese rol especial — quítaselo a esa primero.');
      } else if (err.code === '23505') {
        setError('Ya existe una categoría activa con ese nombre.');
      } else {
        setError(err.message || 'No se pudo guardar la categoría.');
      }
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <h2>{isEdit ? 'Editar categoría' : 'Nueva categoría'}</h2>
        <form onSubmit={handleSubmit} className="patient-form">
          <label className="field">
            <span>Nombre *</span>
            <input value={name} onChange={(e) => setName(e.target.value)} autoFocus placeholder="Ej: Monturas" />
          </label>
          <label className="field">
            <span>Rol especial</span>
            <select value={specialRole} onChange={(e) => setSpecialRole(e.target.value)}>
              {SPECIAL_ROLES.map((r) => (
                <option key={r.value} value={r.value}>
                  {r.label}
                </option>
              ))}
            </select>
            <span className="field-hint">
              La categoría marcada como "Audífonos" es la que usa Audífonos → Nueva venta para armar la lista
              de productos — puedes renombrarla libremente, esto no depende del nombre.
            </span>
          </label>
          {error && <p className="auth-error">{error}</p>}
          <div className="modal-actions">
            <button type="button" className="button-secondary" onClick={onClose} disabled={saving}>
              Cancelar
            </button>
            <button type="submit" className="button-primary" disabled={saving}>
              {saving ? 'Guardando…' : 'Guardar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
